import {EmailMakerCanvasDevice} from '@EmailMakerReact/email-maker-react.types';

export interface DeviceSwitcherProps {
  currentDevice: EmailMakerCanvasDevice;
  onSelect: (device: EmailMakerCanvasDevice) => void;
}

export const EMAIL_MAKER_SWITCHER_DEVICES: readonly EmailMakerCanvasDevice[] = [EmailMakerCanvasDevice.DESKTOP, EmailMakerCanvasDevice.MOBILE];

export const EMAIL_MAKER_DEVICE_ICON: Record<EmailMakerCanvasDevice, string> = {
  [EmailMakerCanvasDevice.DESKTOP]: 'icon-desktop',
  [EmailMakerCanvasDevice.TABLET]: 'icon-ipad',
  [EmailMakerCanvasDevice.MOBILE]: 'icon-mobile',
};

export const EMAIL_MAKER_DEVICE_LABEL_KEY: Record<EmailMakerCanvasDevice, string> = {
  [EmailMakerCanvasDevice.DESKTOP]: 'pmwjs_form_maker_device_desktop',
  [EmailMakerCanvasDevice.TABLET]: 'pmwjs_form_maker_device_tablet',
  [EmailMakerCanvasDevice.MOBILE]: 'pmwjs_form_maker_device_mobile',
};
